import { MapPin2Icon } from "@/shared/icons";

type Props = {
  address: string;
};
export default function OfferLocation({ address }: Props) {
  return (
    <div className="flex items-center gap-2.5 px-1 text-inverted">
      <MapPin2Icon className="w-5" />
      <div className="text-16 font-medium">{address}</div>
    </div>
  );
}
